import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import DualListBox from "../../../duallistBox";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";

type Permission = { id: number; name: string };

type Admin = {
  permissions: Array<number>;
  priority_name: string | null;
  priority_id: number;
};

const SummerCampAddPriority = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const [chosenPermissions, setChosenPermissions] = useState<Permission[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions(); 
  const [isLoading, setIsLoading] = useState(false);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };

  const handlePermissionsChange = (selected: Permission[]) => {
    setChosenPermissions(selected);
    setNewAdmin({
      ...newAdmin,
      permissions: selected.map((permission) => permission.id),
    });
  };
  const [newAdmin, setNewAdmin] = useState<Admin>({
    priority_name: null,
    priority_id: 0,
    permissions: [],
  });

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchPermissionsData = async () => {
    const resposne = await fetch(
      `${webApi}/user/get_permissions_dropdown/`,
      options
    );
    return await resposne.json();
  };

  const fetchData = async () => {
    setIsLoading(true); // Start loading
    try {
      const [permissionsData] = await Promise.all([fetchPermissionsData()]);

      setPermissions(permissionsData.results);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    if (!checkPermission("add_summercamppriority", "summercamppriority")) {
      navigate(routes.adminDashboard);
    } else {
      fetchData();
    }
  }, [userPermissions]);
  


  const updateData = async () => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      body: JSON.stringify(newAdmin),
    };
    const url = `${webApi}/summercamp/priorities/`;
    const response = await fetch(url, requestOptions);
    if (!response.ok) {
      const errorData = await response.json();

      throw new Error("Network response was not ok");
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await updateData();
      navigate(routes.SummerCampPriorities);
    } catch (error) {}
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setNewAdmin({ ...newAdmin, [name]: value || null });
  };

  useEffect(() => {
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;

    // Loop over them and prevent submission
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }

          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">SummerCamp Add Priority</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SummerCampPriorities}>Priorities</Link>
                  </li>
                  <li className="breadcrumb-item active">Add Priority</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add Group */}
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                  
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="form-group mb-3" style={{ width: "35%" }}>
                      <label className="form-label">Priority Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="priority_name"
                        placeholder="Priority Name"
                        onChange={handleInputChange}
                        value={newAdmin.priority_name || ""}
                        required
                      />
                    </div>
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.SummerCampPriorities}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button className="btn btn-primary" type="submit">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
        </div>
      </div>
    </div>
  );
};

export default SummerCampAddPriority;
